export default __webpack_public_path__ + "static/lift_b.e7840e0fb5e7e2c784142f4dea1a5965.png";